// URL slug mappings for SEO-friendly location URLs

// Known service page slugs (for PageResolver - avoids importing ServicePage/Three.js)
export const validServiceSlugs = new Set([
  'managed-it', 'cybersecurity', 'microsoft-365-support', 'network', 'it-strategy', 'compliance', 'help-desk'
]);

// Known industry page slugs
export const validIndustrySlugs = new Set([
  'law-firms', 'accounting', 'healthcare', 'construction', 'real-estate', 'retail'
]);

// City overview pages: IT-support-in-[city] → city data key
export const locationCitySlugs = {
  'IT-support-in-vancouver': 'vancouver',
  'IT-support-in-burnaby': 'burnaby',
  'IT-support-in-surrey': 'surrey',
  'IT-support-in-richmond': 'richmond',
  'IT-support-in-coquitlam': 'coquitlam',
  'IT-support-in-abbotsford': 'abbotsford',
};

// Service slug prefix → service data key
export const locationServiceSlugs = {
  'managed-it-services': 'managed-it',
  'cybersecurity-services': 'cybersecurity',
  'microsoft-365-support': 'microsoft-365-support',
  'network-services': 'network',
  'it-strategy-consulting': 'it-strategy',
  'compliance-services': 'compliance',
  'help-desk-support': 'help-desk',
};

// Reverse lookups (data key → URL slug)
export const cityToSlug = Object.fromEntries(
  Object.entries(locationCitySlugs).map(([slug, key]) => [key, slug])
);

export const serviceToLocationSlug = Object.fromEntries(
  Object.entries(locationServiceSlugs).map(([slug, key]) => [key, slug])
);

// Build combined service+city slugs: e.g. "managed-it-services-in-vancouver" → { city, service }
const cities = Object.values(locationCitySlugs);
const serviceEntries = Object.entries(locationServiceSlugs);

export const locationServiceCombinedSlugs = {};
cities.forEach(city => {
  serviceEntries.forEach(([serviceSlug, serviceKey]) => {
    const combined = `${serviceSlug}-in-${city}`;
    locationServiceCombinedSlugs[combined] = { city, service: serviceKey };
  });
});

// Get city data key from URL slug
export const getCityKey = (slug) => locationCitySlugs[slug] || null;

// Get service data key from URL slug
export const getServiceKey = (slug) => locationServiceSlugs[slug] || null;

// Build service+city URL from data keys
export const getServiceCityUrl = (serviceKey, cityKey) => {
  const serviceSlug = serviceToLocationSlug[serviceKey];
  return serviceSlug ? `/${serviceSlug}-in-${cityKey}` : `/${cityKey}/${serviceKey}`;
};

// Build city overview URL from data key
export const getCityUrl = (cityKey) => {
  const slug = cityToSlug[cityKey];
  return slug ? `/${slug}` : `/${cityKey}`;
};
